import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles';
import {Bubble} from 'react-chartjs-2';
import Typography from '@material-ui/core/Typography';
import { styles } from '../CSS/Styles';
import ChartDataLabels from 'chartjs-plugin-datalabels';
// chart template
// on default, it contains color code, and can be configure in the colorScheme.

// need to pass in :
//            h6 : the tile of the chart, in a list, one element is one row
//            data  : in following format:

//            const data = {
//                labels: [['x-axis label1 row1','x-axis label1 row2'], 
//                         ['x-axis label2 row1','x-axis label2 row2'], 
//                         ['x-axis label3 row1','x-axis label3 row12']],
//                datasets: [
//                    {
//                        stack:'stack1',
//                        label: 'Controls of Assurance',
//                        backgroundColor: setting.COLOR.AMBER,
//                        borderWidth: 0,
//                        data: controlAssuranceCount
//                    },{
//                        stack:'stack1',
//                        label: 'Total Assurance',
//                        backgroundColor: setting.COLOR.BRIGHTYELLOW,
//                        borderWidth: 0,
//                        data: [column1,
//                               column2,
//                               column3]
//                    }
//                ]
//            };

class BubbleChart extends Component {

    render() {
        const { classes } = this.props
        let data = this.props.data
        var maxY = data.datasets.map((item)=>{return item.data[0]['y']})
        maxY = Math.ceil(Math.max(...maxY)*1.3)

        var digits = maxY.toString().length

        var roundOperator = Math.pow(10,digits-1)

        maxY = maxY/roundOperator
        maxY = Math.ceil(maxY)*roundOperator

        var maxX = data.datasets.map((item)=>{return item.data[0]['x']})
        maxX = Math.ceil(Math.max(...maxX)*1.2)

        console.log(maxX)
        let option = {
            onClick: (evt, activeElements)=>{
                if (activeElements[0]==null)return
                var datasetIndex = activeElements[0]._datasetIndex
                console.log(datasetIndex)
                if(this.props.eEvent != null)
                this.props.eEvent(datasetIndex)
            },
            plugins: {
                datalabels: {
                    display: ((context)=>{
                        return this.props.labelDisplay
                    }),
                    formatter: function(value, context) {
                        return context.dataset.label
                    },
                    color: 'black',
                    anchor: 'center',
                    align: 'center'
                }
            },
            responsive: true,
            maintainAspectRatio: true,
            scales: {
                yAxes: [{
                    gridLines: {
                        display: false,
                        drawBorder: true
                    },
                    ticks: {
                        max:maxY,
                        beginAtZero: true,
                        display: true,
                        callback: (label, index, labels) => {
                            if (this.props.axisY != 'amount')
                                return label
                            if(parseInt(label) >= 1000){
                                return '$'+label.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                            }else{
                                return '$' + label;
                            }
                        } 
                    },
                    scaleLabel: {
                        display: this.props.yLabel != null,
                        labelString: this.props.yLabel
                    }
                }],
                xAxes: [{
                    barPercentage: 0.65,
                    gridLines: {
                        display: false,
                        drawBorder: true
                    },
                    ticks: {
                        max:maxX,
                        beginAtZero: true,
                        fontSize: 10
                    },
                    scaleLabel: {
                        display: this.props.xLabel != null,
                        labelString: this.props.xLabel
                    }
                }]
            },
            title: {
                display: false
            },
            legend: {
                position:'bottom',
                display: false
            }
        }

        return (
            <div className={classes.details}>
                {this.props.title === null ? null :
                    this.props.title.map((title, index) => {
                        if (index === 0) {
                            return (
                                <Typography className={classes.title}>
                                    {title}
                                </Typography>
                            )
                        }
                        if (title === '') {
                            return (
                                <Typography className={classes.subtitle}/>
                            )
                        }
                        return (
                            <div>
                                {title.split(' ').map((title)=>{
                                    return (
                                        <Typography variant='subtitle' style={{ color:(isNaN(title) ? 'black' : 'blue'), display:'inline', minHeight: '18px'}}>
                                            {title + ' '}
                                        </Typography>
                                    )
                                })}
                            </div>
                        )
                    })
                }
                <br/>
                <Bubble 
                    data={data} 
                    height={this.props.height != null ? this.props.height : 100} 
                    width={this.props.width != null ? this.props.width : 100} 
                    options={option}
                />

            </div>
        )
    }
}
export default withStyles(styles)(BubbleChart);


// WEBPACK FOOTER //
// ./src/components/CSSComponent/BubbleChart.js